import * as angular from 'angular';
import {IController, IIntervalService, IScope} from "angular";
import {ServiceStatus} from "../../constants/service-status.type";
import {AgentsService} from "../../../agents/services/agents-service.service";
import {AnalyticsService} from "../../../commons/services/analytics-service.service";
import {DeliveriesAlertsService} from "../../services/deliveries-alerts.service";
import {DeliveriesService} from "../../services/deliveries-service.service";
import {SiteContextService} from "../../../commons/services/site-context.service";

export class DeliveriesGroupSelectorCtrl implements IController {
  operation: any;
  agentId: any;
  serviceAreas: any[];

  private agentLocationRef: any;
  private intervalRef: any;
  private readonly PULLING_INTERVAL: any = 15000;

  private siteInfo: any;
  private deliveriesRef: any;
  private serviceAreasRef: any;
  public offlineEnabled: boolean;
  private assignedAgentLocation: any;
  private showHistoryMarkers: any;
  private selectedAction: any;
  private currentNavItem: any;
  public isShowMap: boolean = false;
  public isMapEnabled: boolean = false; // For Mobile support only
  public isSuperOwner: boolean;

  /* @ngInject */
  constructor(private $deliveries, private $scope: IScope, private $state,
              private deliveriesAlertsService: DeliveriesAlertsService, private $interval: IIntervalService,
              private $log, private $serviceArea, private deliveriesService: DeliveriesService,
              private $agentLocation, private splitService,
              private agentsService: AgentsService, private analyticsService: AnalyticsService, private siteContextService: SiteContextService,
              private IAMPermissions) {
    this.deliveriesRef = $deliveries();
    this.serviceAreasRef = $serviceArea();
    this.offlineEnabled = this.splitService.isOfflineEnabled();
  }

  $onInit() {
    this.siteInfo = this.siteContextService.getSiteInfo();
    this.isShowMap = this.siteInfo.showMap;
    this.currentNavItem = this.$state.current.url;
    this.isSuperOwner = this.IAMPermissions.hasRole('super.owner');



    if (!this.serviceAreas) {
      this._getServiceAreas();
    }

    // Barcode Event
    this.$scope.$on('barcode-scanned', (event, barcode) => {
      this.$log.debug('Scan detected, bar code is : ', barcode);
      this.barcodeQuery(barcode);
    });
  }

  $onChanges(changes) {
    if (changes.agentId) {
      if (this.isShowMap){
        this._bindAgentLocation(this.agentId);
      }
    }
  };

  $doCheck() {
    // this.showHistoryMarkers = this.$state.current.url === '/history';
    this.showHistoryMarkers = this.currentNavItem === '/history';
  };

  $onDestroy() {
    if (this.agentLocationRef) {
      this.agentLocationRef.$destroy();
    }

    if (this.intervalRef) {
      this.$interval.cancel(this.intervalRef);
    }
  }

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  onToggleMap() {
    this.isMapEnabled = !this.isMapEnabled;
    this._bindAgentLocation(this.agentId);
  }

  barcodeQuery(barcode) {
    this.deliveriesRef.$getAll({query: barcode})
      .then((deliveryIds) => {
        const deliveryId = deliveryIds[0];
        if (deliveryId) {
          this.deliveriesAlertsService.barcodeScanSuccess(barcode);
          this.$state.go('.', {id: deliveryId});
        } else {
          this.deliveriesAlertsService.barcodeScanError(barcode);
        }
      })
      .catch((error) => {
        this.$log.debug('Fail to barcode query, ' +
          'deliveryDetailedView@barcodeQuery', error);
      })
  }

  toggleShowMap() {
    this.analyticsService.trackEvent('Delivery Actions', 'Show Map', 'Click');
    this.isShowMap = true;
  }

  onSelectAction(action) {
    this.selectedAction = action;
  }

  private _getServiceAreas() {
    const serviceAreaIds = this.deliveriesService.getDeliveryServiceAreasIdsList(this.operation);
    this.serviceAreasRef.$asyncValues(serviceAreaIds)
      .then((serviceAreas) => {
        this.serviceAreas = serviceAreas;
      })
      .catch((error) => {
        if (error) {
          this.$log.error('Error while getting service areas from server, siteMarket Map \n' + error);
        }
      });
  }

  private _bindAgentLocation(agentId) {

    if (this.agentLocationRef) {
      this.agentLocationRef.$destroy();
    }

    if (this.intervalRef) {
      this.$interval.cancel(this.intervalRef);
    }

    if (agentId) {

      this.agentsService.getAgentPreferences(agentId)
        .then((preferences) => {
          if (this.operation.agent) {
            this.operation.agent.agentPreferencesReference = preferences;
          }
        })

      this.agentLocationRef = this.$agentLocation(agentId);

      if (this.operation.status === ServiceStatus.Started) {
        this._getAgentLocation(agentId);
      }

      this.intervalRef = this.$interval(() => {
        if (this.operation.status === ServiceStatus.Started) {
          this._getAgentLocation(agentId);
        }
      }, this.PULLING_INTERVAL);
    }
  }

  private _getAgentLocation(agentId) {
    this.agentsService.getAgentLocation(agentId)
      .then((updatedLocation: any) => {
        const agentCopy = angular.copy(this.operation.agent);
        if (agentCopy) {
          updatedLocation.location = (updatedLocation.location || updatedLocation.coordinates);
          agentCopy.lastKnownLocation = updatedLocation;
          this.operation.agent = agentCopy;
        }
      })
  }

}

angular
  .module('bringoz.admin.deliveries')
  .component('operationDetailedView', {
    bindings: {
      operation: '<',
      agentId: '<?',
      serviceAreas: '<?'
    },
    template: require('./operation-detailed-view.html').default,
    controller: DeliveriesGroupSelectorCtrl
  });
